import { Input, InputProps } from "antd";

export const BasicInput: React.FC<InputProps> = ({ ...inputProps }) => {
  return <Input {...inputProps} size="large" autoCapitalize="none" />;
};
